import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_fill_read",
  "use": "icon-icon_fill_read-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_fill_read\"><path d=\"M928 160h-832A32 32 0 0 0 64 192v640a32 32 0 0 0 32 32h832a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32z m-80.768 108.928l-315.52 245.44a21.504 21.504 0 0 1-26.496 0L189.568 268.928A7.168 7.168 0 0 1 194.048 256h648.768a7.168 7.168 0 0 1 4.416 12.928z\" p-id=\"2970\" fill=\"#2970FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol